module.exports = __webpack_public_path__ + "img/login-logo.a5bf809e.png";